import { useState } from "react";
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button";
import { httprequest } from "../../../data/api";

const ReferralSettings = ({ setCurrentView }) => {
  const [passwordForm, setPasswordForm] = useState({ old_password: "", new_password: "", confirm_password: "" });
  const [isChangingPassword, setIsChangingPassword] = useState(false);

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm((prev) => ({ ...prev, [name]: value }));
  };

  const submitChangePassword = async () => {
    if (!passwordForm.old_password || !passwordForm.new_password || !passwordForm.confirm_password) {
      toast.error("Please fill in all fields");

      return;
    }
    if (passwordForm.new_password !== passwordForm.confirm_password) {
      toast.error("New password and confirm password do not match");

      return;
    }
    setIsChangingPassword(true);
    try {
      await httprequest.patch("/api/v1/change-password", {
        old_password: passwordForm.old_password,
        new_password: passwordForm.new_password
      });
      toast.success("Password Changed Successfully");
      setPasswordForm({ old_password: "", new_password: "", confirm_password: "" });
      setTimeout(() => {
        window.location.href = "/auth/referrer";
      }, 2000);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to change password");
    } finally {
      setIsChangingPassword(false);
    }
  };

  return (
    <main className="ref-dash-main ref-settings-main">
      <div className="ref-settings-header">
        <span className="ref-back-link" onClick={() => setCurrentView("dashboard")}>
          <Icon icon="bx:chevron-left" /> Dashboard <span className="ref-back-divider" style={{ color: "#ccc", margin: "0 8px" }}>|</span> <span style={{ color: "#0065FF" }}>Settings</span>
        </span>
      </div>

      <div className="ref-settings-card">
        <div className="ref-settings-card-header">
          <h3 style={{ fontSize: "20px", fontWeight: "600", marginBottom: "8px", color: "#111" }}>Change Password</h3>
          <p style={{ color: "#666", fontSize: "14px", marginBottom: "24px" }}>Edit your Password</p>
        </div>

        <div className="ref-settings-form" style={{ maxWidth: "400px" }}>
          <div className="ref-form-group-wrap" style={{ marginBottom: "16px" }}>
            <InputGroup
              label="Current Password"
              placeHolder="********"
              inputType="password"
              inputName="old_password"
              value={passwordForm.old_password}
              onChange={handlePasswordChange}
            />
          </div>
          <div className="ref-form-group-wrap" style={{ marginBottom: "16px" }}>
            <InputGroup
              label="New Password"
              placeHolder="********"
              inputType="password"
              inputName="new_password"
              value={passwordForm.new_password}
              onChange={handlePasswordChange}
            />
          </div>
          <div className="ref-form-group-wrap" style={{ marginBottom: "24px" }}>
            <InputGroup
              label="Confirm New Password"
              placeHolder="********"
              inputType="password"
              inputName="confirm_password"
              value={passwordForm.confirm_password}
              onChange={handlePasswordChange}
            />
          </div>
          <div className="ref-settings-submit" style={{ display: "flex", justifyContent: "flex-start", marginTop: "32px" }}>
            <Button
              buttonName={isChangingPassword ? "Saving..." : "Save"}
              variant="primary"
              buttonSize="small"
              color="btndefault"
              onClick={submitChangePassword}
              disabled={isChangingPassword}
              style={{ width: "150px" }}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default ReferralSettings;
